import styled from 'styled-components';

export const ReceiptLink = styled.a`
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  text-decoration-line: none;
  border-bottom: 1px solid #858dbd;
  color: var(--color-text-muted);

  :hover {
    border-bottom: 1px solid transparent;
  }
`;
